// @flow

import React, { Component } from 'react'
import './ActivityList.css'

import CommentCreated from '../Icons/icon-activity-commentcreated.svg'
import ContentCreated from '../Icons/icon-activity-contentcreated.svg'
import Deleted from '../Icons/icon-activity-deleted.svg'
import Downloaded from '../Icons/icon-download-gray.svg'
import Edited from '../Icons/icon-activity-edited.svg'
import Email from '../Icons/icon-activity-emailchanged.svg'
import Folder from '../Icons/icon-activity-folder.svg'
import Liked from '../Icons/icon-activity-liked.svg'
import Loginout from '../Icons/icon-activity-loginout.svg'
import Notified from '../Icons/icon-activity-notificationreceived.svg'
import Opened from '../Icons/icon-activity-opened.svg'
import Scheduled from '../Icons/icon-scheduled-gray.svg'
import Searched from '../Icons/icon-activity-search.svg'
import Video from '../Icons/icon-activity-video.svg'
import Loading from '../Icons/loading.gif'
import { numberedDateLined } from '../timeutils'

import Pageview from '../Icons/icon-activity-pageview.svg'
import Registered from '../Icons/icon-activity-registereduser.svg'
import Admin from '../Icons/icon-admin-gray.svg'
import ExploreView from '../Icons/icon-explore-active.svg'
import Content from '../Icons/icon-content.svg'

type Props = {
  data: Array
}

/**
  * Diplay for activity list
  * @class
  * @extends Component
*/
class ActivityList extends Component<Props> {
  /** render function */
  render () {
    const content = this.props.data.map((entry, index) => {
      if (entry.eventType === 'Loading') {
        return <img key={index || 0} src={Loading} alt='Loading' />
      } else {
        let EventIcons
        const EventToken = entry.eventType.split(' ')
        if (EventToken[EventToken.length - 1] === 'Login' || EventToken[EventToken.length - 1] === 'Logout' || EventToken[0] === 'Password') EventIcons = Loginout
        if ((EventToken[1] === 'Opened' && EventToken[0] !== 'Alert') || (EventToken[1] === 'Opened' && EventToken[0] !== 'Event')) EventIcons = Opened
        if (EventToken[0] === 'Event' && EventToken[1] !== 'Opened') EventIcons = Scheduled
        if (EventToken[1] === 'Deleted' || EventToken[1] === 'Removed' || EventToken[EventToken.length - 1] === 'Device') EventIcons = Deleted
        if (EventToken[1] === 'Edited' || EventToken[1] === 'Updated') EventIcons = Edited
        if (EventToken[1] === 'Liked') EventIcons = Liked
        if (EventToken[1] === 'Downloaded') EventIcons = Downloaded
        if (EventToken[1] === 'Registered') EventIcons = Registered
        if (EventToken[0] === 'Alert' || EventToken[0] === 'Push') EventIcons = Notified
        if (EventToken[0] === 'Email') EventIcons = Email
        if (EventToken[0] === 'Video') EventIcons = Video
        if (EventToken[0] === 'Search') EventIcons = Searched
        if (EventToken[0] === 'Admin') EventIcons = Admin
        if (entry.eventType === 'Comment Created') EventIcons = CommentCreated
        if (entry.eventType === 'Content Created') EventIcons = ContentCreated
        if (entry.eventType === 'Folder Created') EventIcons = Folder
        if (entry.eventType === 'Page View') EventIcons = Pageview
        if (entry.eventType === 'Explorer View') EventIcons = ExploreView
        if (EventIcons === undefined) EventIcons = Content

        return (
          <div key={index} className='ActivityDisplay'>
            <div className='ActivityDesc'>
              <img src={EventIcons} alt={entry.eventType} />
              <span className='activityContent'>{entry.description}</span>
            </div>
            <span className='datestamp'>{numberedDateLined(entry.dateTime.seconds * 1000)}</span>
          </div>
        )
      }
    })

    return (
      <div className='ActivityList box'>
        <h4>
          Activity
        </h4>
        {content}
      </div>
    )
  }
}

export default ActivityList
